// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TableIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TableIcon" ref={forwardedRef} {...props}>
      <path d="M4.496 7h11v1.5H13v7h-1.5v-7h-3v7H7v-7H4.496z" />
      <path d="M4.5 4.5h11v11h-11zM4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TableIcon = /* @__PURE__ */ Object.assign(TableIconComponent, {
  displayName: 'TableIcon',
});
